import { ReportDashboardComponentGridPosition } from './report-component.types';

export enum ReportDashboardComponentChartType {
  Bar = 'bar',
  Column = 'column',
  Line = 'line',
  Pie = 'pie',
}

export enum ReportDashboardComponentKind {
  Trend = 'trend',
  Breakdown = 'breakdown',
  SingleMetric = 'single_metric',
  Funnel = 'funnel',
  TimeBased = 'time_based',
  NetChange = 'net_change',
}

export enum ReportDashboardComponentViewMode {
  Chart = 'chart',
  Summary = 'summary',
  Table = 'table',
}

export enum ReportResourceType {
  Candidates = 'candidates',
  Evaluations = 'evaluations',
  Events = 'events',
  Jobs = 'jobs',
  Views = 'views',
  Visits = 'visits',
  Applications = 'applications',
  Hires = 'hires',
  Requisitions = 'requisitions',
  CustomTimeBased = 'custom_time_based',
  JobStatusSnapshots = 'job-status-snapshots',
}

export enum DetailsType {
  Candidates = 'candidates',
  Evaluations = 'evaluations',
  Events = 'events',
  Jobs = 'jobs',
  Views = 'views',
  Visits = 'visits',
  Applications = 'applications',
  Hires = 'hires',
  Requisitions = 'requisitions',
  CustomTimeBased = 'custom-time-based',
  JobStatusSnapshots = 'job-status-snapshots',
}

export enum ReportDashboardUnavailabilityReason {
  CannotViewReportDashboards = 'cannot_view_report_dashboards',
  TrackingDisabled = 'careers_analytics_disabled',
  RequisitionsDisabled = 'requisitions_disabled',
}

export const DEFAULT_COMPONENT_GRID_POSITION: ReportDashboardComponentGridPosition = {
  cols: 6,
  rows: 2,
  x: 0,
  y: 0,
};

export enum ReportAxis {
  X = 'x',
  Y = 'y',
}

export enum FilterGroup {
  // ATS
  AddedBy = 'added-by',
  DisqualifiedBy = 'disqualified-by',
  HiredBy = 'hired-by',
  Participant = 'participant',
  Job = 'job',
  TalentPool = 'talent-pool',
  JobTag = 'job-tag',
  CandidateTag = 'candidate-tag',
  Source = 'source', // NOTE: legacy, same as FilterGroup.CandidateSourceTag
  SourceOrigin = 'source-origin', // NOTE: legacy, same as FilterGroup.CandidateSource
  Stage = 'stage',
  Status = 'status', // NOTE: legacy, same as FilterGroup.CandidateStatus
  JobCountry = 'job-country',
  JobStatus = 'job-status',
  JobStatusChange = 'job-status-change',
  JobLocation = 'job-location',
  Department = 'department',
  Admin = 'admin',
  Role = 'role',
  CandidateSource = 'candidate-source',
  CandidateSourceTag = 'candidate-source-tag',
  CandidateSourcingOrigin = 'candidate-sourcing-origin',
  CandidateStatus = 'candidate-status',
  DisqualifyReason = 'disqualify-reason',
  DisqualifyKind = 'disqualify-kind',
  InterviewDuration = 'interview-duration',
  InterviewKind = 'interview-kind',
  PlacementType = 'placement-type',
  Rating = 'rating',
  Referrer = 'referrer',
  StageCategory = 'stage-category',
  StageName = 'stage-name',
  StageGroup = 'stage-group',
  Pipeline = 'pipeline',
  EvaluationRequester = 'evaluation-requester',
  EvaluationStatus = 'evaluation-status',
  EvaluationType = 'evaluation-type',
  Guest = 'guest',
  Evaluator = 'evaluator',
  HiringManager = 'hiring-manager',
  Recruiter = 'recruiter',
  RequisitionAge = 'requisition-age',
  RequisitionCountry = 'requisition-country',
  RequisitionLocation = 'requisition-location',
  RequisitionStatus = 'requisition-status',
  WorkModel = 'work-model',
  WorkLocation = 'work-location',
  Country = 'country',
  Location = 'location',

  // used in Kiwi (HR) filters as KIWI_DASHBOARD_FILTERS
  // Also has duplicated country, department, location
  Frequency = 'frequency',
  Gender = 'gender',
  ManagerAnyLevel = 'manager_any_level',
  ManagerDirect = 'manager_direct',
  Nationality = 'nationality',
  Position = 'position',
  Team = 'team',
  WorkSchedule = 'work_schedule',

  CustomField = 'custom_field',
  CandidateField = 'candidate-field', // called Profile Fields

  // Careers
  Page = 'page',
  UtmSource = 'utm-source',
  UtmContent = 'utm-content',
  UtmTerm = 'utm-term',
  UtmMedium = 'utm-medium',
  UtmCampaign = 'utm-campaign',

  JobCategory = 'job-category',
  JobEducation = 'job-education',
  JobExperience = 'job-experience',
  JobHoursPerWeek = 'job-hours-per-week',
  JobSalary = 'job-salary',
  EmploymentType = 'employment-type',
  Requisition = 'requisition',
  RequisitionHiringBudget = 'requisition-hiring-budget',
  RequisitionRequester = 'requisition-requester',
  RequisitionOpeningReason = 'requisition-opening-reason',
  Campaign = 'campaign',
  Channel = 'product',
}
